import { useCallback, useState } from 'react';
import Services from '../../../../../bridge/utils/Services';
import LogsScreen from '../LogsScreen';
import { LogRecordType } from '../../../../../bridge/utils/LogRecord';
import LogsFilter from '../Filter';
import useLogsWebsocket from '../../../../../hooks/useLogsWebsocket';

const ServiceLogs = () => {
  const services = [
    Services.Data,
    Services.CandleFetcher,
    Services.Control,
    Services.Order,
    Services.Exchange,
  ];

  const [activeService, setActiveService] = useState(services[0]);

  const handleServiceChange = useCallback((service: Services) => {
    setActiveService(service);
  }, []);

  const [searchQuery, setSearchQuery] = useState('');
  const [messageTypes, setMessageTypes] = useState([
    LogRecordType.Info,
    LogRecordType.Variable,
    LogRecordType.Error,
  ]);

  const [startTimestamp, setStartTimestamp] = useState<string | undefined>();
  const [endTimestamp, setEndTimestamp] = useState<string | undefined>();

  const amountOfLogs = [200, 500, 1000, 2000, 5000];
  const [maxLogs, setMaxLogs] = useState(amountOfLogs[0]);

  const { logRecords, isLoading } = useLogsWebsocket(
    activeService,
    undefined,
    undefined,
    searchQuery,
    startTimestamp,
    endTimestamp,
  );

  return (
    <div
      style={{
        margin: 20,
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <LogsFilter
        services={services}
        activeService={activeService}
        handleServiceChange={handleServiceChange}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        maxLogs={maxLogs}
        setMaxLogs={setMaxLogs}
        amountOfLogs={amountOfLogs}
        startTimestamp={startTimestamp}
        setStartTimestamp={setStartTimestamp}
        endTimestamp={endTimestamp}
        setEndTimestamp={setEndTimestamp}
        messageTypes={messageTypes}
        setMessageTypes={setMessageTypes}
      />

      <LogsScreen
        id={activeService}
        logRecords={logRecords}
        isLoading={isLoading}
        messageTypes={messageTypes}
        maxLogs={maxLogs}
      />
    </div>
  );
};

export default ServiceLogs;
